export var ORIENTATIONS = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
export var PHOTO_ORIENTATIONS = Object.freeze({
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
});